import { useMutation } from '@apollo/client';
import { PUBLISH_VERSION_MUTATION } from '../operations';

export const usePublishReport = () => {
  const [publishVersionMutation, { data, loading, error }] = useMutation(PUBLISH_VERSION_MUTATION);

  const publishReport = async (report) => {
    if (!report) throw new Error('No report found to publish');

    const versionId = report.smartReportVersions?.[0]?.id;
    if (!versionId) throw new Error('No version found to publish');

    await publishVersionMutation({
      variables: {
        id: versionId,
      },
    });
  };

  return {
    publishReport,
    publishedReport: data?.publishSmartReportVersion || null,
    loading,
    error,
  };
};
